export default __webpack_public_path__ + "static/media/30.39980e91.gif";